export default "<div class=\"spinner\" *ngIf=\"spinnerService.visible\">\n  <mat-spinner></mat-spinner>\n</div>\n";